import { useEffect, useState } from "react";
import { getMyKnockoutPoints } from "../../publicFunctions/registerHandler";
import { getIconByBattleId } from "../../publicFunctions/publicHelpers/homeHelper";
import { IonIcon } from "@ionic/react";

function MyKnockoutPoints({ myProfile, nightMode }) {
  const [currentTotal, setCurrentTotal] = useState(0);
  const [alreadyChecked, setAlreadyChecked] = useState(false);
  const [yearString, setYearString] = useState("");
  const [renderedDetailedPoints, setRenderedDetailedPoints] = useState([]);

  useEffect(() => {
    if (myProfile?.userId && !alreadyChecked && !currentTotal) {
      // get my knockOutPoints for this year
      setAlreadyChecked(true);
      const year = new Date().getFullYear().toString(10);
      setYearString(year + " ");
      getMyKnockoutPoints(year, myProfile.userId)
        .then((result) => {
          if (result) {
            const battles = result.battles;

            const MAX_NUM_OF_BATTLES = 5;
            const currentScores = [];
            const tempRender = [];
            for (let j = 0; j < battles.length; j++) {
              const obj = battles[j];
              currentScores.push(obj.points);
              if (obj.points) {
                tempRender.push(
                  <div
                    className="flex align-items--center flex--gap-normal"
                    key={j.toString(10) + "_season"}
                  >
                    {obj.battleId ? (
                      <IonIcon
                        className="battle-icon--small"
                        icon={getIconByBattleId(obj.battleId)}
                      />
                    ) : null}
                    <p className="description">
                      {getSeasonTitleByBattleId(obj.battleId)}
                    </p>
                    <p className="description bold">{obj.points}</p>
                  </div>
                );
              }
            }
            currentScores.sort((a, b) => {
              return b - a;
            });
            while (currentScores.length > MAX_NUM_OF_BATTLES) {
              currentScores.splice(currentScores.length - 1, 1);
            }

            let totalScore = 0;
            for (let j = 0; j < currentScores.length; j++) {
              totalScore += currentScores[j];
            }
            setCurrentTotal(totalScore);
            setRenderedDetailedPoints(tempRender);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [myProfile]);

  if (!currentTotal) {
    return null;
  }

  return (
    <div>
      <div className="simple-divider"></div>
      <p className="description--larger bold center-text margin-auto margin-top-bigger margin-bottom-sm">
        {yearString + "Knockout Score"}
      </p>
      <p
        className={
          "step-number center-text" + (nightMode ? " off-white" : " dark-blue")
        }
      >
        {currentTotal}
      </p>
      <br />
      <br />
      <div>{renderedDetailedPoints}</div>
      <br />
      <br />
      <p className="description--small">
        The writer with the highest Knockout Score at the end of the year is
        crowned the MVW and wins <strong>$2,000</strong> cash. We count your
        best 5 out of 7 Battle knockout points in the calendar year to determine
        your Knockout Score. Not participating in a Battle counts as zero for
        that Battle.
        <br />
        <br />
        Knockout points for a Battle are calculated as follows...
        <br />
        <em>In the Final Showdown, you were knocked out in the:</em>
        <br />
        Thrilling 32 - 5 points
        <br />
        Sweet 16 - 10 points
        <br />
        Elite 8 - 15 points
        <br />
        Ferocious 4 - 20 points
        <br />
        Runner-up - 25 points
        <br />
        Winner - 30 points
        <br />
      </p>
    </div>
  );
}

function getSeasonTitleByBattleId(battleId) {
  if (!battleId) {
    return "";
  }
  let toReturn = "";
  if (battleId.includes("heart")) {
    toReturn = "Heart";
  } else if (battleId.includes("feb")) {
    toReturn = "Winter";
  } else if (battleId.includes("wonder")) {
    toReturn = "Wonder";
  } else if (battleId.includes("may")) {
    toReturn = "Spring";
  } else if (battleId.includes("aug")) {
    toReturn = "Summer";
  } else if (battleId.includes("fear")) {
    toReturn = "Fear";
  } else if (battleId.includes("nov")) {
    toReturn = "Autumn";
  }
  return toReturn;
}

export default MyKnockoutPoints;
